import axiosInstance from "../../../core/api/axios";
import { practiceFilterStoreStore } from "../stores/practiceFilterStore";
import { practiceRevisionFilterStore } from "../stores/practiceRevisionFilterStore";

export const getPractices = async () => {
  try {
    const rate = practiceFilterStoreStore.getState().rate;
    const modality = practiceFilterStoreStore.getState().modality;
    const essay = practiceFilterStoreStore.getState().essay;
    let rateString = '', modalityString = '', essayString = '';

    if(rate.length === 1 && rate.includes('under-average')) {
      rateString = 'under-average'
    }

    if(rate.length === 1 && rate.includes('over-half')) {
      rateString = 'over-half'
    }

    if(essay.length === 1 && essay.includes('w_essay')) {
      essayString = 'has_essay';
    }

    if(essay.length === 1 && essay.includes('n_essay')) {
      essayString = 'hasnt_essay';
    }

    if(modality.length > 0) {
      modalityString = JSON.stringify(modality)
    }

    const { data } = await axiosInstance.get(`/examsimulator/exams/user/complete?rate=${rateString}&modality=${modalityString}&essay=${essayString}`)

    const sortedData = data.sort((a: any, b: any) => {
      if(a.createdAt > b.createdAt) {
        return -1
      } else {
        return 1
      }
    })

    return sortedData;
  } catch(e: any) {
    throw new Error(e);
  }
}

export const getPracticeExam = async () => {
  try {
    const { data } = await axiosInstance.get(`/examsimulator/areas`)

    return data
  } catch(e: any) {
    throw new Error(e);
  }
}

export const getPractice = async (id: string) => {
  try {
    const { data } = await axiosInstance.get(`/examsimulator/${id}`)

    return data;
  } catch(e: any) {
    throw new Error(e)
  }
}

export const getPracticeFeedback = async (id: string) => {
  try {
    const { data } = await axiosInstance.get(`/examsimulator/feedback/${id}`);

    const newEssay = {
      id: data.essay._id,
      status: data.essay.status,
      theme: data.essay.theme,
      tryNumber: data.essay.tryNumber,
      essayTheme: data.essay.essayTheme
    }

    const newObject = {
      title: data.title,
      essay: newEssay,
      exercises: data.exercises,
      resolutions: data.resolutions,
      timeSpent: data?.timeSpent || null,
      score: data.score
    }

    return newObject;
  } catch(e: any) {
    throw new Error(e)
  }
}

export const getCredits = async () => {
  try {
    const { data } = await axiosInstance.get(`/essays/credits`)

    return data;
  } catch(e: any) {
    throw new Error(e);
  }
}

export const getRevisions = async () => {
  try {
    const list = practiceRevisionFilterStore.getState().list;
    const exam = practiceRevisionFilterStore.getState().exam;
    const disciplines = practiceRevisionFilterStore.getState().discipline;
    let listKind = 'all', examParsed = '', disciplinesParsed = '';
    
    if(list.length < 2 && list.includes('now')) {
      listKind = 'now'
    }

    if(list.length < 2 && list.includes('after')) {
      listKind = 'after'
    }

    if(exam.length > 0) {
      examParsed = JSON.stringify(exam);
    }

    if(disciplines.length > 0) {
      disciplinesParsed = JSON.stringify(disciplines)
    }

    const { data } = await axiosInstance.get(`/examsimulator/revision?list=${listKind}&exam=${examParsed}&disciplines=${disciplinesParsed}`);

    return data;
  } catch(e: any) {
    throw new Error(e)
  }
}

export const getRevisionExercises = async (id: string) => {
  try {
    const { data } = await axiosInstance.get(`/examsimulator/revision/${id}`);

    return data;
  } catch(e: any) {
    throw new Error(e)
  }
}